const searchInput = document.getElementById("search-input");
const predictionsList = document.getElementById("predictions");
let activeIndex = -1;
let predictions = [];

searchInput.addEventListener("input", () => {
  const searchValue = searchInput.value.toLowerCase();
  predictions = searchArray.filter((item) =>
    item.text.toLowerCase().includes(searchValue)
  );
  activeIndex = -1;
  showPredictions(predictions);
});

function showPredictions(predictions) {
  predictionsList.innerHTML = "";
  if (predictions.length > 0) {
    predictions.forEach((prediction, index) => {
      const li = document.createElement("li");
      li.textContent = prediction.text;
      li.dataset.index = index;
      li.addEventListener("click", () => {
        window.location.href = prediction.link; // Navigate to link
      });
      predictionsList.appendChild(li);
    });
    updateActiveIndex();
  }
}

function updateActiveIndex() {
  const lis = predictionsList.children;
  for (let i = 0; i < lis.length; i++) {
    if (i === activeIndex) {
      lis[i].classList.add("active");
    } else {
      lis[i].classList.remove("active");
    }
  }
}

searchInput.addEventListener("keydown", (e) => {
  switch (e.key) {
    case "Escape":
      e.preventDefault();
      searchInput.value = "";
      predictionsList.innerHTML = "";
      activeIndex = -1;
      break;
    case "ArrowDown":
      if (activeIndex < predictions.length - 1) {
        activeIndex++;
        updateActiveIndex();
        const activeLi = predictionsList.children[activeIndex];
      }
      break;
    case "ArrowUp":
      if (activeIndex > 0) {
        activeIndex--;
        updateActiveIndex();
        const activeLi = predictionsList.children[activeIndex];
      } else if (activeIndex === 0) {
        activeIndex = -1;
        updateActiveIndex();
        searchInput.focus();
      }
      break;
    case "Enter":
      e.preventDefault();
      if (activeIndex >= 0 && activeIndex < predictions.length) {
        const prediction = predictions[activeIndex];
        console.log(prediction.link);
        window.location.href = prediction.link; // Navigate to link
      }
      break;
  }
});

// Close predictions list when clicking outside
document.addEventListener("click", (e) => {
  if (!searchInput.contains(e.target) && !predictionsList.contains(e.target)) {
    predictionsList.innerHTML = "";
    activeIndex = -1;
  }
});
